import { reduce } from 'lodash';
import {
  MapBoxContext,
  MapBoxContextSelectOption,
  MapBoxGeometryType,
  MapBoxPlace,
  MapBoxPlacesFeature,
  MapBoxPlacesResponse,
  PlaceSelectOption,
} from './geolocation.model';

export const mapMapBoxPlacesToSelectOptions = (
  geolocations: MapBoxPlacesResponse | undefined,
  valuePlace: MapBoxPlace | undefined
): PlaceSelectOption[] | undefined =>
  geolocations?.features?.map((feature) =>
    mapMapBoxPlacesFeatureToPlaceSelectOption(feature, valuePlace)
  );

export const mapMapBoxPlacesFeatureToPlaceSelectOption = (
  feature: MapBoxPlacesFeature | undefined,
  valuePlace: MapBoxPlace | undefined
) => {
  const context = mapMapBoxPlacesResponseToContext(feature?.context);
  const [longitude, latitude] = (feature?.geometry?.type === MapBoxGeometryType.Point &&
    feature.geometry.coordinates?.length === 2 &&
    feature.geometry.coordinates) || [undefined, undefined];

  const res: PlaceSelectOption = {
    label: feature?.place_name || '',
    value: {
      id: feature?.id,
      labelShort: mapMapBoxPlacesResponseToValue(feature, context, valuePlace),
      labelLong: feature?.place_name,
      longitude,
      latitude,
      context,
    },
  };
  return res;
};

export const mapMapBoxPlacesResponseToValue = (
  feature: MapBoxPlacesFeature | undefined,
  context: MapBoxContextSelectOption | undefined,
  valuePlace: MapBoxPlace | undefined
) => {
  const value = valuePlace
    ? feature?.place_type?.includes(valuePlace)
      ? valuePlace === MapBoxPlace.Street
        ? feature.place_name || ''
        : feature.text_de || ''
      : (context && context[valuePlace]?.text) || ''
    : feature?.text_de || '';
  return value || feature?.place_name;
};

export const mapMapBoxPlacesResponseToContext = (context: MapBoxContext[] | undefined) =>
  reduce(
    context,
    (akk, item) => {
      const splited = item.id?.split('.');
      const field = (splited?.length && splited[0]) || undefined;

      return !!field
        ? {
            ...akk,
            [field]: item,
          }
        : akk;
    },
    {} as MapBoxContextSelectOption
  );

export const getPlaceIndex = (valuePlace: MapBoxPlace | undefined) => valuePlace || 'no_place';
